<template>
  <div class="repair-receipt-print">
    <table class="rcp-table">
      <thead>
        <tr>
          <td class="rcp-header" colspan="6">
            <div class="rcp-header-row">
              <div class="rcp-header-logo">
                <img
                  src="/media/logos/vdd_hori_logo.png"
                  alt="logo"
                  class="rcp-logo"
                >
              </div>
              <div class="rcp-header-title">
                <h1 class="rcp-title">BIÊN NHẬN</h1>
                <div class="rcp-title-en">CUSTOMER RECEIPT</div>
              </div>
              <div class="rcp-header-store">
                <div class="rcp-store-name">{{ storeName }}</div>
                <div class="rcp-store-meta">{{ storeAddress }}</div>
                <div class="rcp-store-meta">Thời gian làm việc: 10h - 20h</div>
                <div class="rcp-store-meta">
                  Điện thoại: <strong>{{ storePhone }}</strong>
                </div>
                <div class="rcp-store-meta">
                  Hotline phản hồi chất lượng dịch vụ: <strong>18006729</strong>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr class="rcp-section-head">
          <th colspan="2">Thông tin khách hàng / <i>Customer Data</i></th>
          <th colspan="2">Thông tin sản phẩm / <i>Data Products</i></th>
          <th colspan="2">Thông tin nhận máy / <i>Receipt Info</i></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="rcp-label">
            <div>Họ &amp; Tên</div>
            <div class="rcp-en"><i>Name</i></div>
          </td>
          <td class="rcp-value">{{ slip.customerName || '-' }}</td>
          <td class="rcp-label">
            <div>Loại máy</div>
            <div class="rcp-en"><i>Model</i></div>
          </td>
          <td class="rcp-value">{{ deviceModel || '-' }}</td>
          <td class="rcp-label">
            <div>Số biên nhận</div>
            <div class="rcp-en"><i>Receipt Number</i></div>
          </td>
          <td class="rcp-value"><strong>{{ slip.slipNumber || '-' }}</strong></td>
        </tr>
        <tr>
          <td class="rcp-label">
            <div>Địa chỉ</div>
            <div class="rcp-en"><i>Address</i></div>
          </td>
          <td class="rcp-value">{{ slip.customerAddress || '-' }}</td>
          <td class="rcp-label">
            <div>Số IMEI/ SN</div>
            <div class="rcp-en"><i>IMEI/ SN number</i></div>
          </td>
          <td class="rcp-value">{{ slip.imei || 'không' }}</td>
          <td class="rcp-label">
            <div>Ngày nhận</div>
            <div class="rcp-en"><i>Date Received</i></div>
          </td>
          <td class="rcp-value">{{ formatDate(slip.createdAt) }}</td>
        </tr>
        <tr>
          <td class="rcp-label">
            <div>Điện thoại</div>
            <div class="rcp-en"><i>Phone</i></div>
          </td>
          <td class="rcp-value">{{ slip.customerPhone || '-' }}</td>
          <td class="rcp-label">
            <div>Tình trạng bảo hành</div>
            <div class="rcp-en"><i>Warranty Status</i></div>
          </td>
          <td class="rcp-value">{{ warrantyTypeName }}</td>
          <td class="rcp-label">
            <div>Ngày trả</div>
            <div class="rcp-en"><i>Date Returned</i></div>
          </td>
          <td class="rcp-value">
            {{ returnDateDisplay }}
            <small v-if="!slip.returnedAt && slip.appointmentDate" class="text-muted d-block">
              (dự kiến)
            </small>
          </td>
        </tr>
        <tr>
          <td
            class="rcp-section-head rcp-fault-head"
            colspan="4"
          >
            Thông tin lỗi của máy / <i>Fault Description</i>
          </td>
          <td class="rcp-label">
            <div>Mật khẩu máy</div>
            <div class="rcp-en"><i>Password</i></div>
          </td>
          <td class="rcp-value"><strong>{{ machinePasswordDisplay }}</strong></td>
        </tr>
        <tr>
          <td
            class="rcp-fault-body rcp-value"
            colspan="4"
            rowspan="2"
          >
            {{ slip.customerDescription || '-' }}
          </td>
          <td class="rcp-label">
            <div>Phí sửa chữa</div>
            <div class="rcp-en"><i>Cost</i></div>
          </td>
          <td class="rcp-value">{{ formatMoney(slip.totalAmount) }}</td>
        </tr>
        <tr>
          <td class="rcp-label">Ghi chú / <i>Note</i>:</td>
          <td class="rcp-value">{{ slip.technicianNote || '' }}</td>
        </tr>
        <tr>
          <td
            class="rcp-rules"
            colspan="4"
            rowspan="3"
          >
            <div class="rcp-rules-title"><i>Qui định sửa chữa</i></div>
            <ol class="rcp-rules-list">
              <li>Thời gian bảo hành sửa chữa tại Viện Di Động: 05-10 ngày tùy tình trạng máy.</li>
              <li>Thời gian gửi Hãng bảo hành: 15 - 45 ngày tùy từng Hãng.</li>
              <li>Công ty không chịu trách nhiệm về dữ liệu trên máy và các phụ kiện kèm theo: sim, thẻ nhớ, ốp lưng, dán màn hình ..., quý khách vui lòng tự lưu giữ.</li>
              <li>Trường hợp máy: Mất nguồn / Treo Logo / Lỗi màn hình / Tự Reset / Lên Tắt, công ty không chịu trách nhiệm các chức năng trên máy và trả về tình trạng <strong>mất nguồn hoàn toàn</strong> khi không xử lý được.</li>
              <li>Thiết bị sau khi mở kiểm tra sẽ được xử lý trên linh kiện - main, không còn khả năng kháng nước như khi xuất xưởng và không thể trả về tình trạng như ban đầu.</li>
              <li>Biên nhận có giá trị trong 03 tháng kể từ ngày nhận máy, sau 03 tháng máy sẽ được thanh lý theo quy định công ty.</li>
              <li><strong>Quý khách vui lòng mang theo biên nhận khi đến nhận lại máy. Xin cảm ơn !</strong></li>
            </ol>
          </td>
          <td
            class="rcp-product-name"
            colspan="2"
          >
            {{ slip.productName || '-' }}
          </td>
        </tr>
        <tr>
          <td class="rcp-sign-cell">
            <div class="rcp-sign-role">
              Tiếp tân:<br>
              <i>Receptionist</i>
            </div>
          </td>
          <td class="rcp-sign-cell">
            <div class="rcp-sign-direction">Nhận máy/ in</div>
            <div class="rcp-sign-direction-r">Trả máy / out</div>
          </td>
        </tr>
        <tr>
          <td class="rcp-sign-cell">
            <div class="rcp-sign-role">
              Khách hàng<br>
              <i>Customer</i>
            </div>
          </td>
          <td class="rcp-sign-cell">
            <div class="rcp-sign-direction">Gửi máy / in</div>
            <div class="rcp-sign-direction-r">Nhận máy / out</div>
          </td>
        </tr>
        <tr>
          <td
            class="rcp-footer-confirm"
            colspan="6"
          >
            Tôi đã kiểm tra <strong>đúng đủ</strong> các thông tin
            Và <strong>đồng ý</strong> với các quy định sửa chữa
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PrintRepairReceipt',
  props: {
    slip: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    storeName() {
      return (this.slip.store && this.slip.store.name) || 'Viện Di Động';
    },
    storeAddress() {
      return (this.slip.store && this.slip.store.address) || '';
    },
    storePhone() {
      return (this.slip.store && this.slip.store.phoneNumber) || '';
    },
    warrantyTypeName() {
      // "Loại BH" giờ là SP bảo hành (productType=5) — snapshot trên phiếu.
      return this.slip.warrantyProductName || '-';
    },
    deviceModel() {
      const name = this.slip.productName || '';
      const brand = this.slip.brandName ? `${this.slip.brandName} ` : '';
      return `${brand}${name}`.trim() || '-';
    },
    /**
     * Ngày trả: ưu tiên returnedAt (đã trả thật) → fallback appointmentDate (ngày hẹn).
     * Khi in biên nhận lúc nhận máy, hiển thị ngày HẸN trả cho khách biết;
     * khi in lại sau khi đã trả, hiển thị ngày trả thực tế.
     */
    returnDateDisplay() {
      if (this.slip.returnedAt) {
        return this.formatDate(this.slip.returnedAt);
      }
      if (this.slip.appointmentDate) {
        return this.formatDate(this.slip.appointmentDate, 'DD/MM/YYYY');
      }
      return '';
    },
    /**
     * Khi user in phiếu không có quyền xem PIN, BE trả machinePasswordMasked=true.
     * Vẫn hiển thị '••••••' để xác nhận KH có cung cấp, mà không lộ giá trị thật.
     */
    machinePasswordDisplay() {
      if (this.slip.machinePasswordMasked) return '••••••';
      return this.slip.machinePassword || 'không';
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '';
      const fmt = arguments.length > 1 ? arguments[1] : 'DD/MM/YYYY HH:mm:ss';
      return moment(value).format(fmt);
    },
    formatMoney(value) {
      const num = Number(value);
      if (!num) return '';
      return num.toLocaleString('vi-VN');
    },
  },
};
</script>

<style scoped>
.repair-receipt-print {
  width: 210mm;
  margin: 0 auto;
  font-family: 'Times New Roman', serif;
  font-size: 11pt;
  color: #000;
  background: #fff;
  padding: 6mm;
}
.rcp-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.rcp-table td,
.rcp-table th {
  border: 1px solid #000;
  padding: 4px 6px;
  vertical-align: top;
  font-size: 11pt;
}
.rcp-header {
  border: none !important;
  padding: 0 0 8px 0 !important;
}
.rcp-header-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.rcp-header-logo {
  flex: 0 0 28%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rcp-header-title {
  flex: 0 0 30%;
  text-align: center;
}
.rcp-header-store {
  flex: 1;
  text-align: right;
  font-size: 10pt;
}
.rcp-logo {
  max-height: 40mm;
  max-width: 100%;
  object-fit: contain;
}
.rcp-title {
  font-size: 28pt;
  font-weight: 700;
  margin: 6px 0 0 0;
  font-style: italic;
}
.rcp-title-en {
  font-style: italic;
  font-size: 14pt;
  margin-top: 2px;
}
.rcp-store-name {
  font-weight: 700;
  font-size: 11pt;
}
.rcp-store-meta {
  line-height: 1.3;
}
.rcp-section-head {
  background: #fff;
  font-weight: 700;
  text-align: left;
}
.rcp-fault-head {
  font-weight: 700;
}
.rcp-label {
  width: 16%;
  font-weight: 600;
}
.rcp-en {
  font-style: italic;
  font-weight: 400;
  font-size: 10pt;
  color: #333;
}
.rcp-value {
  width: 17%;
}
.rcp-fault-body {
  height: 22mm;
  vertical-align: top;
}
.rcp-rules {
  vertical-align: top;
}
.rcp-rules-title {
  font-weight: 700;
  text-decoration: underline;
  font-style: italic;
  margin-bottom: 4px;
}
.rcp-rules-list {
  margin: 0;
  padding-left: 18px;
  font-style: italic;
  line-height: 1.4;
}
.rcp-rules-list li {
  margin-bottom: 2px;
}
.rcp-product-name {
  font-weight: 600;
  text-align: left;
  vertical-align: top;
  height: 28mm;
}
.rcp-sign-cell {
  height: 16mm;
  position: relative;
}
.rcp-sign-role {
  font-weight: 600;
}
.rcp-sign-direction {
  display: inline-block;
  width: 50%;
  border-right: 1px dashed #000;
  font-size: 10pt;
  padding-right: 4px;
}
.rcp-sign-direction-r {
  display: inline-block;
  width: 49%;
  font-size: 10pt;
  padding-left: 4px;
}
.rcp-footer-confirm {
  text-align: right;
  font-style: italic;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
}
@media print {
  .repair-receipt-print {
    padding: 0;
  }
  @page {
    size: A4 portrait;
    margin: 8mm;
  }
}
</style>
